import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {ContractLinkSummaries} from '../models/contract-link';

export const returnPlayerActionTypes = {
  UPDATE_STATUS: type('[Return Player] Update Status'),
  UPDATE_STATUS_SUCCESS: type('[Return Player] Update Status success'),
  UPDATE_STATUS_FAIL: type('[Return Player] Update Status fail'),
  LOAD_SUMMARY_INFO: type('[Return Player] Load Summary'),
  LOAD_SUMMARY_SUCCESS: type('[Return Player] Load Summary Success'),
};

export class ReturnPlayerUpdateStatusAction implements Action {
  readonly type = returnPlayerActionTypes.UPDATE_STATUS;
  // tslint:disable-next-line:no-any
  constructor(public payload?: any) {}
}
export class ReturnPlayerUpdateStatusSuccessAction implements Action {
  readonly type = returnPlayerActionTypes.UPDATE_STATUS_SUCCESS;
  constructor(public payload?: string) {}
}
export class ReturnPlayerUpdateStatusFailAction implements Action {
  readonly type = returnPlayerActionTypes.UPDATE_STATUS_FAIL;
  constructor(public payload?: string) {}
}

export class ReturnPlayerLoadSummaryInfoAction implements Action {
  readonly type = returnPlayerActionTypes.LOAD_SUMMARY_INFO;
  constructor(public payload?: string) {}
}
export class ReturnPlayerLoadSummaryInfoSuccessAction implements Action {
  readonly type = returnPlayerActionTypes.LOAD_SUMMARY_SUCCESS;
  constructor(public payload?: string) {}
}
